// SweetAlert2 has no central config in this codebase (60+ ad hoc Swal.fire
// call sites) — this reads the currently active design tokens so a themed
// palette/dark-mode reaches SweetAlert2 without touching every call site at
// once. Spread the result into Swal.fire({ ...swalTheme(), ... }); anything
// passed after the spread (e.g. a destructive-action's red confirm button)
// still wins.
export const swalTheme = () => {
  const cs = getComputedStyle(document.documentElement);
  const read = (name) => cs.getPropertyValue(name).trim();
  return {
    background: read('--surface-card'),
    color: read('--text-primary'),
    confirmButtonColor: read('--color-primary'),
    cancelButtonColor: read('--status-neutral'),
  };
};

export const swalDangerColor = () => getComputedStyle(document.documentElement).getPropertyValue('--status-danger').trim();
